import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage (fallback) to all requests
api.interceptors.request.use((config) => {
  const tok = localStorage.getItem("access_token");
  if (tok) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore di rete";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (typeof e === "string" ? e : e?.msg || JSON.stringify(e))).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export function formatCHF(amount) {
  return new Intl.NumberFormat("it-CH", { style: "currency", currency: "CHF" }).format(amount || 0);
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("it-CH", {
    weekday: "short", day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit"
  });
}

export function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("it-CH", {
    weekday: "long", day: "2-digit", month: "long", year: "numeric"
  });
}

export function formatTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("it-CH", { hour: "2-digit", minute: "2-digit" });
}
